// useCaseMapping.js
const useCase2NameMapping = new Map();
useCase2NameMapping.set("GENERIC", "Chat");
useCase2NameMapping.set("REGIS", "Regis - New Energy Legislation");
useCase2NameMapping.set("STORAGE_IMS", "Enport OTD IMS M-Files");

export default useCase2NameMapping;
